import { CommonModule } from '@angular/common';
import { NgModule, Optional, SkipSelf } from '@angular/core';

import { RouteGuard, ValidationGuard } from './guards';
import { CoursesResolver, CourseTemplatesResolver, RegionsResolver } from './resolvers';
import {
  CountryService,
  CourseService,
  CourseTemplateService,
  EnrollService,
  GlobalFunctionsService,
  PaymentService,
  PostalCodeService,
  RegionService
} from './services';

@NgModule({
  imports: [CommonModule],
  providers: [
    CountryService,
    CourseService,
    CourseTemplateService,
    EnrollService,
    GlobalFunctionsService,
    PaymentService,
    PostalCodeService,
    RegionService,
    RouteGuard,
    ValidationGuard,
    CoursesResolver,
    CourseTemplatesResolver,
    RegionsResolver
  ]
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error('CoreModule is already loaded. Import it in the AppModule only');
    }
  }
}
